import { render } from "./Domicliation.vue?vue&type=template&id=5ca35cdc&scoped=true"
import script from "./Domicliation.vue?vue&type=script&lang=js"
export * from "./Domicliation.vue?vue&type=script&lang=js"

import "./Domicliation.vue?vue&type=style&index=0&id=5ca35cdc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ca35cdc"]])

export default __exports__